module.exports = __webpack_public_path__ + "img/id-card.05799917.png";